import * as dtos from "@/models/dtos";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox2.vue";
import InputText from "@/features/shared/components/form/InputText2.vue";
import InputTextWithHelpLink from "@/features/shared/components/form/InputTextWithHelpLink.vue";
import InputFile from "@/features/shared/components/form/InputFile.vue";
import InputTextarea from "@/features/shared/components/form/InputTextarea.vue";
import InputCheckboxGroup from "@/features/shared/components/form/InputCheckboxGroup2.vue";
import InputPeriodCheckboxGroup from "@/features/shared/components/form/InputPeriodCheckboxGroup.vue";
import InputPeriodCheckbox from "@/features/shared/components/form/InputPeriodCheckbox.vue";
import InputRadioGroup from "@/features/shared/components/form/InputRadioGroup.vue";
import InputRadio from "@/features/shared/components/form/InputRadio.vue";
import { FormItemModel } from "./CheckboxGroup";
import {
  DynamicPropertyGroupModel,
  DynamicPropertyGroupPeriodModel,
} from "./DynamicPropertyGroupModel";
import store from "@/store";
import { PeriodProperty } from "@/models/dtos";

export class FormBuilder2 {
  metadata: dtos.MetaData;
  Items: Array<FormItemModel> = [];
  showAll: boolean;
  private firstSort = false;
  constructor(metadata: dtos.MetaData, showAll: boolean) {
    this.showAll = showAll;
    this.metadata = metadata;
    if (this.metadata.properties === undefined) this.metadata.properties = [];
    this.create();
  }
  addInput(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputText, item));
  }
  addInputWithHelpLink(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputTextWithHelpLink, item));
  }
  addInputFile(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputFile, item));
  }
  addTextArea(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputTextarea, item));
  }
  addTextWithHelpLink(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputTextWithHelpLink, item));
  }
  addCheckbox(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputCheckbox, item));
  }
  addRadioButton(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputRadio, item));
  }
  addPeriodCheckbox(
    item: dtos.DynamicProperty,
    periods: Array<dtos.DynamicProperty>
  ) {
    this.metadata.properties.push(item);
    this.Items.push(new FormItemModel(InputPeriodCheckbox, item));
  }
  setOrder() {
    let i = this.Items.length + 1;
    if (this.firstSort) {
      this.Items.forEach((px: FormItemModel, i: number) => {
        const prop = this.metadata.properties.find((x) => {
          return x.key === px.item.key;
        });
        px.item.order = prop.order;
      });
      this.sort();
      this.firstSort = false;
    } else {
      this.Items.forEach((px: FormItemModel, i: number) => {
        px.item.order = i;
      });
    }
    this.metadata.properties.forEach((x: dtos.DynamicProperty, ii: number) => {
      const prop = this.Items.find((px: FormItemModel) => {
        return px.item.key === x.key;
      });

      if (typeof undefined === typeof prop) {
        x.order = i++;
      }
    });
    // this.sort();
  }
  public addMetadata(item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
  }

  removeByProperty(item: dtos.DynamicProperty) {
    const index2 = this.Items.findIndex((px: FormItemModel) => {
      return px.item.key === item.key;
    });
    if (index2 === -1) {
      return;
    }
    this.Items.splice(index2, 1);
    const index = this.metadata.properties.findIndex(
      (px: dtos.DynamicProperty) => {
        return px.key === item.key;
      }
    );
    if (index === -1) {
      return;
    }
    this.metadata.properties.splice(index, 1);
  }
  removeByPropertyFromGroup(
    parent: dtos.DynamicProperty,
    parentData: DynamicPropertyGroupModel,
    item: dtos.DynamicProperty
  ) {
    const index = this.metadata.properties.findIndex(
      (px: dtos.DynamicProperty) => {
        return px.key === item.key;
      }
    );

    const id = parentData.keys.findIndex((px) => {
      return px.key == item.key;
    });
    parentData.keys.splice(id, 1);

    const index2 = this.Items.findIndex((px: FormItemModel) => {
      return px.item.key === parent.key;
    });

    if (index2 === -1) return;

    this.Items.splice(index2, 1);
    this.metadata.properties.splice(index, 1);
  }
  setPeriodItem(item: dtos.DynamicProperty) {
    const entity = this.Items.find((px) => px.item.key == item.key);

    if (entity) {
      entity.item = item;
      entity.item.data.keys = item.data.keys;
      // newItems;
    }
    const metaProperty = this.metadata.properties.find(
      (px) => px.key == item.key
    );
    if (metaProperty) {
      metaProperty.data.keys = item.data.keys;
      metaProperty.data.label = item.label;
    } else {
      this.metadata.properties.push(item);
    }
  }

  setPeriodDataItem(item: dtos.DynamicProperty) {
    const entity = this.Items.find((px) => px.item.key == item.key);
    if (entity) {
      entity.item.data = item.data;
    }
    const metaProperty = this.metadata.properties.find(
      (px) => px.key == item.key
    );
    if (metaProperty) {
      metaProperty.data = item.data;
      metaProperty.label = item.label;
      metaProperty.placeholder = item.label;
      metaProperty.validators = item.validators;
    }
  }

  setCheckboxGroupLabel(item: dtos.DynamicProperty, label: string) {
    const entity = this.Items.find((px) => px.item.key == item.key);
    if (entity) {
      entity.item.data.label = label;
      entity.item.label = label;
      entity.item.placeholder = label;
    }
    const metaProperty = this.metadata.properties.find(
      (px) => px.key == item.key
    );
    if (metaProperty) {
      metaProperty.data.label = label;
      metaProperty.placeholder = label;
      metaProperty.label = label;
    }
  }
  addCheckboxGroup(item: dtos.DynamicProperty) {
    const propertyJson = JSON.stringify(item);

    const model = new FormItemModel(
      InputCheckboxGroup,
      JSON.parse(propertyJson)
    );
    model.item.data = new DynamicPropertyGroupModel();
    model.item.data.label = item.placeholder;

    item.data.keys.forEach((element: any) => {
      const prop = this.metadata.properties.find((px) => {
        return px.key === element;
      });
      model.item.data.keys.push(prop);
    });
    this.Items.push(model);
  }
  addPeriodCheckboxGroup(item: dtos.DynamicProperty) {
    const propertyJson = JSON.stringify(item);

    const model = new FormItemModel(
      InputPeriodCheckboxGroup,
      JSON.parse(propertyJson)
    );

    model.item.data = new DynamicPropertyGroupPeriodModel();
    /*     model.item.data.checked = false;
     model.item.data.startDate = item.data.startDate;
     model.item.data.endDate = item.data.endDate;
*/
    item.data.keys.forEach((element: any) => {
      const prop = this.metadata.properties.find((px) => {
        return px.key === element;
      });
      model.item.data.keys.push(prop.key);
      model.item.data.metadata = this.metadata;
    });
    this.Items.push(model);
  }
  addRadioGroup(item: dtos.DynamicProperty) {
    const propertyJson = JSON.stringify(item);

    const model = new FormItemModel(InputRadioGroup, JSON.parse(propertyJson));

    model.item.data = new DynamicPropertyGroupPeriodModel();

    item.data.keys.forEach((element: any) => {
      const prop = this.metadata.properties.find((px) => {
        return px.key === element;
      });
      model.item.data.keys.push(prop.key);
      model.item.data.metadata = this.metadata;
    });
    this.Items.push(model);
  }
  removePeriodFromGroup(item: dtos.DynamicProperty) {
    if (item.type === "periodCheckbox") {
      const groups = this.metadata.properties.filter(
        (px) => px.type === "periodGroup"
      );
      if (groups) {
        groups.forEach((group) => {
          if (group.data.keys.includes(item.key)) {
            group.data.keys = group.data.keys.filter(
              (px: string) => px !== item.key
            );
          }
        });
        this.removeByProperty(item);
      }
    }
  }
  addPeriodToGroup(groupKey: string, period: dtos.DynamicProperty) {
    this.metadata.properties.push(period);
    this.metadata.properties
      .find((formItem: any) => formItem.key === groupKey)
      .data.keys.push(period.key);

    this.Items.find(
      (formItem: FormItemModel) => formItem.item.key === groupKey
    ).item.data.keys.push(period.key);
  }
  removeRadioFromGroup(item: dtos.DynamicProperty) {
    if (item.type === "radio") {
      const groups = this.metadata.properties.filter(
        (px) => px.type === "radioGroup"
      );
      if (groups) {
        groups.forEach((group) => {
          if (group.data.keys.includes(item.key)) {
            group.data.keys = group.data.keys.filter(
              (px: string) => px !== item.key
            );
          }
        });
        this.removeByProperty(item);
      }
    }
  }
  addRadioToGroup(groupKey: string, item: dtos.DynamicProperty) {
    this.metadata.properties.push(item);
    this.metadata.properties
      .find((formItem: any) => formItem.key === groupKey)
      .data.keys.push(item.key);

    this.Items.find(
      (formItem: FormItemModel) => formItem.item.key === groupKey
    ).item.data.keys.push(item.key);
  }
  changeRadioButtonLabel(key: string, label: string) {
    const radioButton = this.metadata.properties.find(
      (property: dtos.DynamicProperty) => property.key === key
    );

    if (radioButton) {
      radioButton.label = label;
      radioButton.placeholder = label;
    }
  }

  addOptionToGroup(parent: DynamicPropertyGroupModel, groupKey: string) {
    // const item = new dtos.DynamicProperty();
    const item = new dtos.DynamicProperty();
    item.placeholder = "";
    item.type = "checkbox";
    item.key = crypto.randomUUID();
    item.label = "";
    item.data = null;

    this.metadata.properties.push(item);
    this.metadata.properties
      .find((formItem: any) => formItem.key === groupKey)
      .data.keys.push(item.key);

    this.Items.find(
      (formItem: FormItemModel) => formItem.item.key === groupKey
    ).item.data.keys.push(item);
  }
  removeOptionFromGroup(
    parent: DynamicPropertyGroupModel,
    item: dtos.DynamicProperty,
    formKey: string
  ) {
    const index = parent.keys.findIndex((px) => {
      return px.key === item.key;
    });

    if (index === -1) return;
    parent.keys.splice(index, 1);

    const metadataIndex = this.metadata.properties.findIndex((px) => {
      return px.key === item.key;
    });

    if (metadataIndex === -1) return;
    this.metadata.properties.splice(metadataIndex, 1);

    const metadataGroupIndex = this.metadata.properties.findIndex((px) => {
      return px.key === formKey;
    });
    if (metadataGroupIndex === -1) return;
    this.metadata.properties[metadataGroupIndex].data.keys.splice(index, 1);

    const formItemIndex = this.Items.findIndex((px) => {
      return px.item.key === formKey;
    });
    const itemIndex = this.Items[formItemIndex].item.data.keys.findIndex(
      (px: any) => {
        return px.key === item.key;
      }
    );
    if (itemIndex === -1) return;

    this.Items[formItemIndex].item.data.keys.splice(itemIndex, 1);
  }

  createProperty(placeholder: string, type: string): dtos.DynamicProperty {
    // formbuilderStore is a Vuex module — its state isn't part of the typed
    // root state, so cast to any (mirrors the previous useStore<any>() behavior).
    const x = (store.state as any).formbuilderStore.counter++;
    const item = new dtos.DynamicProperty();
    item.placeholder = placeholder;
    item.type = type;
    item.key = "form_" + x;
    item.label = placeholder;
    return item;
  }
  private sort() {
    this.Items.sort((a, b) => (a.item.order > b.item.order ? 1 : -1));
  }
  private create(): Array<FormItemModel> {
    if (typeof undefined === typeof this.metadata.properties) return this.Items;

    // this.metadata.properties;
    // .sort((a, b) => (a.type < b.type ? 1 : -1))
    // .sort((a, b) => (a.order < b.order ? 1 : -1));

    this.metadata.properties.sort().forEach((px) => {
      if (this.showAll && px.type === "text") {
        this.Items.push(new FormItemModel(InputText, px));
      }
      if (px.type === "text" && px.key.startsWith("form_"))
        this.Items.push(new FormItemModel(InputText, px));
      else if (px.type === "textarea" && (px.key.startsWith("form_") || px.key.startsWith("textarea_")))
        this.Items.push(new FormItemModel(InputTextarea, px));
      else if (px.type === "email")
        this.Items.push(new FormItemModel(InputText, px));
      else if (px.type === "file") {
        this.Items.push(new FormItemModel(InputFile, px));
      } else if (px.type === "textWithHelpLink") {
        this.Items.push(new FormItemModel(InputTextWithHelpLink, px));
      } else if (px.type === "radioGroup") {
        px.data.keys.forEach((element: any) => {
          this.metadata.properties.find((px2) => {
            return px2.key === element;
          });
        });
        this.addRadioGroup(px);
      } else if (px.type === "periodGroup") {
        const periods = [] as Array<dtos.DynamicProperty>;
        px.data.keys.forEach((element: any) => {
          const checkboxItem = this.metadata.properties.find((px2) => {
            return px2.key === element;
          });
          periods.push(checkboxItem);
        });

        this.addPeriodCheckboxGroup(px);
      } else if (px.type === "group") {
        px.data.keys.forEach((element: any) => {
          const checkboxItem = this.metadata.properties.find((px2) => {
            return px2.key === element;
          });
        });
        this.addCheckboxGroup(px);
      }
    });
    this.sort();
    return this.Items;
  }
}
